<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToTip'
});
</script>
<template>
	<div v-if="isShow || position === 'top' || position === 'center'" :key="langKey" ref="tipRef" :flex="flex ? flex : null" class="to-tip" :class="setClass" @mouseenter="mouseEnterHandle" @mouseleave="mouseLeaveHandle">
		<div class="to-tip-wrapper">
			<to-icon v-if="icon" class="to-tip-icon" :value="String(icon)"></to-icon>
			<div class="to-tip-content">
				<slot>{{ content }}</slot>
			</div>
			<to-button v-if="removable" class="to-tip-remove" @click="remove">{{ t('to.tip.dontShowAgain') }}</to-button>
			<to-icon v-if="closable" value="close" link class="to-tip-close" @click="colseAction()"></to-icon>
		</div>
	</div>
</template>
<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { tipProps, tipEmits } from './tip'
import { ToIcon, ToButton } from '@touchvue/components'
import { t, langKey } from '@touchvue/locale'
let instance = getCurrentInstance()

const tipRef = ref(null)
const isShow = ref(true)
const timer = ref(null)
const props = defineProps(tipProps)
const emit = defineEmits(tipEmits)

function openAction() {
	if (props.close) {
		const fn = props.open()
		if (fn && typeof (fn as any).then === 'function') {
			;(fn as Promise<boolean>)
				.then(() => {
					isShow.value = true
				})
				.catch(error => {
					console.log(error, 'error')
					isShow.value = false
				})
		} else {
			if (fn) {
				isShow.value = true
			} else {
				isShow.value = false
			}
		}
	} else {
		isShow.value = true
	}
}

const setClass = computed(() => {
	let arr = []
	// 操作按钮显示状态
	if (props.opDisplay === 'always' || props.position === 'top' || props.position === 'center') {
		arr.push('op-display-always')
	}

	// 显示位置
	if (props.position) {
		arr.push(`position-${props.position}`)
	}

	// 是否显示
	if (isShow.value && (props.position === 'top' || props.position === 'center')) {
		arr.push('is-show')
	}

	// 自定义类名
	if (props.className) {
		arr.push(props.className)
	}

	// 通用颜色参数添加
	if (props.color) {
		arr.push(`color-${props.color}`)
	}

	// 通用类型参数添加
	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}

	return arr
})
if (props.position === 'top' || props.position === 'center') {
	isShow.value = false
} else {
	openAction()
}
onMounted(() => {
	if (props.position === 'top' || props.position === 'center') {
		// 把 DOM 结构放到 body:last-child 位置，避免被 overflow
		document.body.appendChild(tipRef.value)
	}
})
onBeforeUnmount(() => {
	if (props.position === 'top' && tipRef.value) {
		// 销毁移动过的 DOM
		document.body.removeChild(tipRef.value)
	}
})
const mouseEnterHandle = () => {
	if (props.position === 'top') {
		clearTimer()
	}
}
const mouseLeaveHandle = () => {
	if (props.position === 'top') {
		startTimer()
	}
}
const remove = () => {
	isShow.value = false
	emit('remove')
}
const clearTimer = () => {
	clearTimeout(timer.value)
	timer.value = null
}
const startTimer = () => {
	if (Number(props.during) > 0) {
		timer.value = setTimeout(() => {
			// close()
			colseAction()
			clearTimer()
		}, Number(props.during))
	}
}
const close = () => {
	isShow.value = false
	emit('close')
}

function colseAction() {
	if (props.close) {
		const fn = props.close()
		if (fn && typeof (fn as any).then === 'function') {
			;(fn as Promise<boolean>)
				.then(() => {
					close()
				})
				.catch(error => {
					console.log(error)
				})
		} else {
			if (fn) {
				close()
			}
		}
	} else {
		close()
	}
}

const open = () => {
	if (props.position === 'top' || props.position === 'center') {
		;(instance?.proxy?.$el as HTMLElement).style.zIndex = (window as any).$TouchUI?.zIndex.toString()
		;(window as any).$TouchUI.zIndex++
	}
	// isShow.value = true
	openAction()
	clearTimer()
	startTimer()
}

// 暴露方法
defineExpose({ open, close })
</script>
